export default __webpack_public_path__ + "static/media/colordesigner.2663c140.webp";